export default __webpack_public_path__ + "static/media/myName.77dabeee.png";